import { AB_PIN_DETAIL_FULLSCREEN } from "@/constants/ABMng";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import useAppStore from "@/context/store";
import useABTest from "@/utils/hooks/useABtest";
import { useRouter } from "next/router";
import qs from "qs";
import getNextDetailsSetp from "../getHistorySetp";

export function usePin() {
  const { pinOpenType, currentPin } = useAppStore(
    ({ pinOpenType, currentPin }) => ({ pinOpenType, currentPin })
  );
  const router = useRouter();

  // 获取全屏详情页 AB 测试结果
  const pinDetailFullscreen = useABTest(AB_PIN_DETAIL_FULLSCREEN);
  const isFullScreenMode = pinDetailFullscreen.new;

  const onPinClick = ({
    pin,
    param,
    currentSrc,
    searchWord,
    event,
  }: {
    pin: IPin;
    param?: string;
    currentSrc?: string;
    searchWord?: string;
    event: React.MouseEvent;
  }) => {
    if (event.metaKey || event.ctrlKey || pinOpenType === PIN_OPEN_TYPE.BLANK) {
      return;
    }

    event.preventDefault();

    const pinId = pin.pin_id;
    const href = `/pins/${pinId}${param || ""}`;
    const withSearchWordHref = searchWord
      ? `${href}${href.indexOf("?") !== -1 ? "&" : "?"}searchWord=${searchWord}`
      : href;

    if (pinOpenType === PIN_OPEN_TYPE.BLANK) {
      window.open(withSearchWordHref);
      return;
    }

    const pathname = router.pathname;

    // 判断是采集详情弹窗
    if (pathname === "/pins/[pinId]" && !currentPin) {
      // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
      window._pinDetailCurrentSrc = currentSrc;
      router.push(withSearchWordHref);
    } else {
      if (isFullScreenMode) {
        // 全屏详情页：使用多弹窗堆栈模式
        const { pushPinToStack } = useAppStore.getState();
        const pinData = {
          ...pin,
          pinId,
          // 用于渐进式显示图片，先显示缓存图，再显示大图
          currentSrc,
          ...(searchWord ? { searchWord } : null),
        };

        pushPinToStack(pinData);
        let historyData =
          typeof history?.state === "object" ? history?.state : {};
        const search = qs.stringify({ searchWord }, { addQueryPrefix: true });
        // 使用 pinId 而不是 stackIndex 来标识弹窗
        // 添加序列号用于判断前进/后退方向
        const nextSeq = (historyData.seq || 0) + 1;
        window.history.pushState(
          {
            ...historyData,
            modalPinId: pinId,
            isModal: true,
            seq: nextSeq,
          },
          null,
          `/pins/${pinId}${search}`
        );
      } else {
        // 非全屏详情页：使用原有的单弹窗模式
        // currentSrc用于渐进式显示图片，先显示缓存图，再显示大图
        useAppStore.setState({
          currentPin: { pinId, currentSrc, searchWord, ...pin },
        });
        let detailsSetp = getNextDetailsSetp();
        window.history.pushState(detailsSetp, null, href);
      }
    }
  };

  return { onPinClick };
}
